import { useMemo } from 'react';
import { Box, Collapse } from '@mantine/core';
import { useTimelineContext } from '@/hooks/useTimelineContext';
import { MessageBoxType } from './types';
import { ChatMessageBox } from '@/components/Timeline/TimelineMessageBox/ChatMessageBox';
import { CoverageActivityMessageBox } from '@/components/Timeline/TimelineMessageBox/CoverageActivityBox';
import { RefundRequestMessageBox } from '@/components/Timeline/TimelineMessageBox/RefundRequestBox';
import { EncounterChartBox } from '@/components/Timeline/TimelineMessageBox/EncounterChartBox';
import { LabOrderMessageBox } from '@/components/Timeline/TimelineMessageBox/LabOrderMessageBox';
import { SmsMessageBox } from '@/components/Timeline/TimelineMessageBox/SmsMessageBox';
import { StandaloneNoteMessageBox } from '@/components/Timeline/TimelineMessageBox/StandaloneNoteMessageBox';
import { TaskMessageBox } from '@/components/Timeline/TimelineMessageBox/TaskMessageBox';
import { EnabledTopic } from '@/services/timeline-threads';

type TimelineMessageBoxProps = {
  enabledTopics: EnabledTopic[];
  handleNavigateToItem?: (itemReference: string) => void;
};

export function TimelineMessageBox({ enabledTopics, handleNavigateToItem }: TimelineMessageBoxProps) {
  const { messageBoxContext } = useTimelineContext();
  const { messageBoxVariant, showMessageInput } = messageBoxContext;

  const renderContent = useMemo(() => {
    const messageBoxMap = {
      [MessageBoxType.CHAT]: <ChatMessageBox enabledTopics={enabledTopics} />,
      [MessageBoxType.SMS]: <SmsMessageBox />,
      [MessageBoxType.STANDALONE_NOTE]: <StandaloneNoteMessageBox />,
      [MessageBoxType.ENCOUNTER]: <EncounterChartBox handleNavigateToItem={handleNavigateToItem} />,
      [MessageBoxType.LAB_ORDER]: <LabOrderMessageBox />,
      [MessageBoxType.TASK]: <TaskMessageBox />,
      [MessageBoxType.COVERAGE_ACTIVITY]: <CoverageActivityMessageBox />,
      [MessageBoxType.REFUND_REQUEST]: <RefundRequestMessageBox />,
    };

    return messageBoxMap[messageBoxVariant];
  }, [messageBoxVariant, enabledTopics, handleNavigateToItem]);

  return (
    <Collapse in={showMessageInput}>
      <Box px="md" mb="md">
        {renderContent}
      </Box>
    </Collapse>
  );
}
